import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBag, ArrowRight } from "lucide-react";
import { useCart } from "../context/Store";
import { fmt } from "../lib/api";

const HIDDEN_ON = ["/cart", "/checkout", "/payment-result", "/admin", "/partner", "/auth"];

export default function StickyCart() {
  const { cart } = useCart();
  const location = useLocation();
  const show = cart.count > 0 && !HIDDEN_ON.some((p) => location.pathname.startsWith(p));

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ type: "spring", stiffness: 320, damping: 28 }}
          className="fixed bottom-4 inset-x-4 z-40 md:hidden"
          data-testid="sticky-cart"
        >
          <Link
            to="/cart"
            className="flex items-center gap-3 rounded-full bg-brand-navy/95 backdrop-blur-md border border-white/10 shadow-[0_12px_40px_rgba(4,11,22,0.5)] pl-4 pr-2 py-2"
          >
            <span className="relative">
              <ShoppingBag className="h-5 w-5 text-brand-cyan" />
              <span className="absolute -top-1.5 -right-1.5 h-4 min-w-4 px-0.5 rounded-full brand-gradient-bg text-white text-[9px] font-bold flex items-center justify-center">
                {cart.count}
              </span>
            </span>
            <span className="flex-1 text-white text-sm font-semibold" data-testid="sticky-cart-total">{fmt(cart.total)}</span>
            <span className="flex items-center gap-1.5 rounded-full brand-gradient-bg text-white text-xs font-bold px-4 py-2.5">
              View Cart <ArrowRight className="h-3.5 w-3.5" />
            </span>
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
